// ProtectedRoute.js
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isDemoAuthEnabled, getAuthToken } from "./auth";

const ProtectedRoute = () => {
  const token = getAuthToken();
  const demo = isDemoAuthEnabled();

  // In demo, allow access if token exists — set by Demo button below
  if (demo && token) return <Outlet />;

  // Normal behavior otherwise
  return token ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
